module.exports = __webpack_public_path__ + "img/spiner.2a18bff7.png";